<template>
    <div class="message-item__content--swiper-icon">
        <div class="swiper-icon">
            <swiper ref="iconSwiperComponent" :options="swiperOptions">
                <swiper-slide
                    class="swiper__item"
                    v-for="(item, index) in swiperList"
                    :key="index">
                    <div class="swiper__inner"
                        @click="clickItem(item.data)">
                        <div class="swiper__icon"
                            :style="{
                                'background-image': `url(${item.image})`
                            }"></div>
                        <div class="swiper__name">{{item.name}}</div>
                    </div>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev"
                    v-show="(swiperList.length > 1) && swiperIsOver">
                    <span class="navigation__icon icon_arrow-right"></span>
                </div>
                <div class="swiper-button-next" slot="button-next"
                    v-show="(swiperList.length > 1) && swiperIsOver">
                    <span class="navigation__icon icon_arrow-right"></span>
                </div>
            </swiper>
        </div>
    </div>
</template>

<script>
    import { sendMessage } from '@/utils/message_send'
    import { MESSAGE_NAME } from '@/constants/message'

    let IconSwiper = null // swiper实例

    export default {
        name: 'MessageContentSwiperIcon',
        props: {
            swiperList: {
                type: Array,
                required: true
            }
        },
        data () {
            return {
                swiperOptions: {
                    observer: true,
                    observeParents: true,
                    slidesPerView: 'auto',
                    spaceBetween: 5,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        disabledClass: 'swiper-button-disabled'
                    }
                },
                swiperIsOver: false // 是否超出容器
            }
        },
        computed: {
            isDesktop () {
                return this.$eventBus.isDesktop
            }
        },
        methods: {
            clickItem ({ type, text, url }) {
                if (type === 'text') {
                    sendMessage({
                        type: 'base',
                        detailType: MESSAGE_NAME.TEXT,
                        content: text
                    })
                    this.$eventBus.$emit('showinputstatus', {is_input:true})
                } else if (type === 'url') {
                    window.location.href = url
                }
            },
            initSwiperOptions () {
                if (this.isDesktop) {
                    this.swiperOptions.spaceBetween = 10
                }
            },
            swiperComputed () {
                this.$nextTick(() => {
                    IconSwiper = this.$refs.iconSwiperComponent.swiper
                    let slides = Array.from(IconSwiper.slides)
                    let slideWidth = slides.reduce((sum, curr) => {
                        return sum + curr.clientWidth + 10
                    }, 0)
                    this.swiperIsOver = slideWidth > IconSwiper.width
                })
            }
        },
        created () {
            this.initSwiperOptions()
        },
        mounted () {
            this.swiperComputed()

            window.onresize = () => {
                this.swiperComputed()
            }
        },
        beforeDestroy () {
            window.onresize = () => {}
        }
    }
</script>

<style lang="scss" scoped>
    .swiper-container {
        /deep/ .swiper-button {
            &-next {
                right: 7px; // 右侧滚动条的影响
            }
        }
    }

    .swiper {
        &__item {
            position: relative;
            width: 84px;
            height: 94px;
        }

        &__inner {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            text-align: center;
            overflow: hidden;
            background-color: #ffffff;
            box-shadow: $primary-box-shadow;
            @include radius(.5);

            &:active {
                background-color: darken(#ffffff, 7%);
            }
        }

        &__icon {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            margin: 15px auto 0;
            background: 50% 50% no-repeat;
            background-size: cover;
        }

        &__name {
            font-size: 12px;
            line-height: 1;
            color: $primary-text-color;
            margin: 12px 5px 0;
            @include text-line(1);
        }
    }
</style>
